module.exports = __webpack_public_path__ + "static/media/goose.5576e82b.jpg";